import React from "react";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import { formatNumber } from "utils/currencyFormat";
import { getDate, currentDate, formatDayMonth } from "utils/formatDate";
import { pushNotification } from "utils/notifications";
import LanThanhToanView from "../LanThanhToanView";
import TatToanChoDuyetApi from "../../../service/tatToanChoDuyetApi";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { convertDate } from "utils/formatDate";
import QuanLyChoVayApi from "service/quanLyChoVayApi";

class ThayDoiKyThanhToan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      choVay: {},
      dataSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 10,
      },
      objDoiKyLaiThanhToan: {
        choVayId: 0,
        NgayThucHien: currentDate(),
        CountTypePaid: 1,
        note: "",
      },
      dataDoiKyLaiSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 2,
      },
      HasTatToanChoDuyet: 0,
      lichSu: [],
    };
  }
  componentDidMount() {
    let { data, show } = this.props;
    let { choVay, objDoiKyLaiThanhToan } = this.state;
    if (data && data !== choVay && data.ChoVayId && show) {
      let { dataSearch, dataDoiKyLaiSearch } = this.state;
      dataSearch.choVayId = data.ChoVayId;
      dataDoiKyLaiSearch.choVayId = data.ChoVayId;
      objDoiKyLaiThanhToan.choVayId = data.ChoVayId;
      objDoiKyLaiThanhToan.NgayThucHien = currentDate();
      this.setState({
        choVay: data,
        dataSearch,
        objDoiKyLaiThanhToan,
        dataDoiKyLaiSearch,
      });
      this.loadLanDongLai(dataSearch);
      this.loadLichSuDoiKyThanhToan(data.ChoVayId);
      this.kiemTraHopDongChoVayTatToanChoDuyet();
    }
    if (data === choVay && !show) this.setState({ choVay: {} });
  }
  kiemTraHopDongChoVayTatToanChoDuyet() {
    let { data } = this.props;
    let { HasTatToanChoDuyet } = this.state;
    TatToanChoDuyetApi.kiemTraHopDongChoVayTatToanChoDuyet(data.ChoVayId).then(
      (response) => {
        if (
          response.data != undefined &&
          response.data != null &&
          response.data.TatToanChoDuyet
        ) {
          HasTatToanChoDuyet = response.data.TatToanChoDuyet;
          this.setState({ HasTatToanChoDuyet });
        }
      }
    );
  }
  loadLanDongLai(dataSearch) {
    let { getLanDongLaiChoVay } = this.props;
    getLanDongLaiChoVay(dataSearch);
  }
  // loadLichSuDoiKyThanhToan(dataSearch) {
  //   let { getLichSuDoiKyThanhToanChoVay } = this.props;
  //   getLichSuDoiKyThanhToanChoVay(dataSearch);
  // }

  loadLichSuDoiKyThanhToan(choVayId) {
    if (choVayId != null && choVayId != undefined) {
      QuanLyChoVayApi.lichSuDoiKyThanhToan({ choVayId }).then((response) => {
        if (response.status === 200) {
          this.setState({ lichSu: response.data }); // gán vào state
        }
      });
    }
  }

  ResetLaiKyThanhToan(choVayId) {
    if (choVayId != null && choVayId != undefined) {
      QuanLyChoVayApi.resetLaiKyThanhToan({ choVayId }).then((response) => {
        if (response.status === 200) {
          this.setState({ lichSu: response.data }); // gán vào state
        }
      });
    }
  }

  onChangeDate = (field) => (evt) => {
    let { objDoiKyLaiThanhToan } = this.state;
    objDoiKyLaiThanhToan[field] = formatDayMonth(evt);
    this.setState({ objDoiKyLaiThanhToan });
  };
  onChangeData = (field) => (event) => {
    let { objDoiKyLaiThanhToan } = this.state;
    objDoiKyLaiThanhToan[field] = event.target.value;
    this.setState(objDoiKyLaiThanhToan);
  };
  handlePageChange = () => (pageNumber) => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = pageNumber;
    this.setState({ dataSearch });
    this.loadLanDongLai(dataSearch);
  };
  handlePageChangeDoiKyLai = (pageNumber) => {
    let { dataDoiKyLaiSearch } = this.state;
    dataDoiKyLaiSearch.pageIndex = pageNumber;
    this.setState({ dataDoiKyLaiSearch });
    this.loadLichSuDoiKyThanhToan(dataDoiKyLaiSearch);
  };
  thayDoiKyThanhToan = () => () => {
    let { dataSearch, objDoiKyLaiThanhToan } = this.state;
    let { postThayDoiKyThanhToanChoVay } = this.props;

    // if (!objDoiKyLaiThanhToan.count) {
    //   pushNotification("Nhập số lần gia hạn", "warning", "TOP_CENTER", 1000);
    //   return;
    // }

    if (!objDoiKyLaiThanhToan.note) {
      pushNotification("Nhập ghi chú", "warning", "TOP_CENTER", 1000);
      return;
    }

    postThayDoiKyThanhToanChoVay(
      {
        ...objDoiKyLaiThanhToan,
      },
      dataSearch
    );
    objDoiKyLaiThanhToan.NgayThucHien = "";
    objDoiKyLaiThanhToan.note = "";
    this.setState({ objDoiKyLaiThanhToan });
  };
  renderRow(List) {
    return List.map((item, index) => {
      var lstTP = [];
      if (item.ThuPaid) lstTP = item.ThuPaid.split(",");
      return (
        <tr key={"LanDongLai" + index}>
          <td>{item.IndexId}</td>
          <td className="text-left"> {getDate(item.Time)}</td>
          <td className="text-right">
            {formatNumber(item.ValueGoc + item.ValuePaid)}
          </td>
          <td className="text-right">{formatNumber(item.Paided)}</td>
          <td className="text-right">
            {lstTP.map((itemPaid, idexTP) => {
              var itemPaids = itemPaid.split("#");
              return (
                <p className="text-center">
                  <a href={() => false}>
                    {formatNumber(itemPaids[2]).replace(".00", "")}
                  </a>
                  <span className="date-sm">({getDate(itemPaids[1])})</span>
                </p>
              );
            })}
          </td>
        </tr>
      );
    });
  }

  onChangeDate = (field) => (evt) => {
    let { objDoiKyLaiThanhToan } = this.state;
    objDoiKyLaiThanhToan[field] = formatDayMonth(evt);
    this.setState({ objDoiKyLaiThanhToan });
  };

  renderDoiKyLaiRow(lichSu) {
    return lichSu.map((item, index) => {
      return (
        <tr className="">
          <td>{item.Id}</td>
          <td className="text-left">{getDate(item.Time)}</td>
          <td className="text-right">{item.NoiDung}</td>
          <td className="text-left">{item.GhiChu}</td>
        </tr>
      );
    });
  }
  render() {
    let props = this.props;
    let { data, quanlychovay, buttonLeft, chonngaygiaodich } = this.props;
    let {
      List,
      TongCanThanhToan,
      TongPhiKhac,
      TongPhiKho,
      TongThanhToan,
      TongTienGoc,
      TongTienLai,
      totalRow,
      TongPhiKhacHangKy,
    } = quanlychovay.objListDonglai;
    let { LichSuDoiKyThanhToan, TotalRowDoiKyLai } =
      quanlychovay.LichSuDoiKyThanhToan;
    let {
      getLanDongLaiChoVayLoading,
      getLichSuDoiKyThanhToanChoVayLoading,
      postThayDoiKyThanhToanChoVayLoading,
    } = quanlychovay;
    let { dataSearch, dataDoiKyLaiSearch, objDoiKyLaiThanhToan } = this.state;
    let { NgayThucHien, note } = objDoiKyLaiThanhToan;
    if (NgayThucHien) NgayThucHien = convertDate(NgayThucHien);
    let { Type, StatusPaidHo } = data;
    return (
      <Modal
        {...props}
        size="modal-xl modal-xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="mdi mdi-table-plus"></i>
            </span>
            Thay đổi kỳ thanh toán
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <div
            className={
              "loader loader-default " +
              (getLanDongLaiChoVayLoading ||
              getLichSuDoiKyThanhToanChoVayLoading ||
              postThayDoiKyThanhToanChoVayLoading
                ? "is-active"
                : "")
            }
          ></div>
          {this.state.HasTatToanChoDuyet === 1 && (
            <>
              <div className="row">
                <div className="col-md-12">
                  <div className="thongbaotattoan">
                    <i class="mdi mdi-alert" style={{ color: "#d39c00" }}></i>{" "}
                    HỢP ĐỒNG ĐANG CHỜ DUYỆT YÊU CẦU TẤT TOÁN
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="row">
            <div className="col-md-12 col-lg-4 pad-right0">
              <div className="tattoan-formleft">
                <ul className="nav nav-tabs bg-tab">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      id="base-tab1"
                      data-toggle="tab"
                      aria-controls="tab1"
                      href="#tab-thongtintt"
                      aria-expanded="true"
                    >
                      <h4>Đổi kỳ thanh toán</h4>
                    </a>
                  </li>
                </ul>
                <div className="tab-content px-1 pt-1 pb-1 bg-content-tab">
                  <div
                    role="tabpanel"
                    className="tab-pane active"
                    id="tab-thongtintt"
                  >
                    <div className="detail-tattoan">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label for="projectinput1">Mã cho vay</label>
                            <span className="home-new-blue giahan-block">
                              {data.Code}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Ngày đổi kỳ</label>
                            <DateTimePicker
                              value={NgayThucHien}
                              onChange={this.onChangeDate("NgayThucHien")}
                              readOnly={!chonngaygiaodich}
                            ></DateTimePicker>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label for="projectinput1">
                              Kỳ đóng lãi/kỳ góp cũ
                            </label>
                            <input
                              disabled={true}
                              type="text"
                              className="form-control input-sm"
                              value={data.CountTypePaid}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label for="projectinput1">
                              Kỳ đóng lãi/kỳ góp mới
                            </label>
                            <input
                              type="text"
                              className="form-control input-sm"
                              // value={data.CountTypePaid}
                              onChange={this.onChangeData("CountTypePaid")}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label for="projectinput8">Lý do thay đổi</label>
                            <textarea
                              rows="3"
                              className="form-control input-sm"
                              placeholder=""
                              value={note}
                              onChange={this.onChangeData("note")}
                            ></textarea>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="text-right">
                            {this.state.HasTatToanChoDuyet !== 1 && (
                              <button
                                type="button"
                                className="btn btn-new-main btn-checknew"
                                onClick={this.thayDoiKyThanhToan()}
                              >
                                <span className="btn-icon-left">
                                  <i className="mdi mdi-table-plus"></i>
                                </span>{" "}
                                Xác nhận
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="text-right">
                            {this.state.HasTatToanChoDuyet !== 1 && (
                              <button
                                type="button"
                                className="btn btn-new-main btn-checknew"
                                onClick={this.ResetLaiKyThanhToan()}
                              >
                                <span className="btn-icon-left">
                                  <i className="mdi mdi-table-plus"></i>
                                </span>{" "}
                                Reset
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="detail-giahan">
                      <h4>Lịch sử Thay đổi kỳ thanh toán</h4>
                      <div className="Left808x200 Table-main-morman table-noboder-new">
                        <div className="table-responsive table-new1">
                          <table className="table table-bordered table-hover">
                            <thead>
                              <tr>
                                <th className="w-5">STT</th>
                                <th className="w-15">Ngày</th>
                                <th className="w-20 text-right">Nội dung</th>
                                <th className="text-left">Lý do</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.renderDoiKyLaiRow(this.state.lichSu)}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="footer-page-new">
                        <div className="row">
                          <div className="col-xl-12 col-lg-12">
                            <div className="paniation-new d-flex just-end">
                              <nav aria-label="Page navigation">
                                <Pagination
                                  activePage={dataDoiKyLaiSearch.pageIndex}
                                  itemsCountPerPage={
                                    dataDoiKyLaiSearch.pageSize
                                  }
                                  totalItemsCount={TotalRowDoiKyLai}
                                  pageRangeDisplayed={10}
                                  onChange={this.handlePageChangeDoiKyLai}
                                  itemClass="page-item"
                                  linkClass="page-link"
                                  activeClass="active"
                                />
                              </nav>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-8">
              <div className="tattoan-formright">
                <ul className="nav nav-tabs bg-tab">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      id="base-tab1"
                      data-toggle="tab"
                      aria-controls="tab1"
                      href="#tab-detailtt"
                      aria-expanded="true"
                    >
                      <h4>Chi tiết đóng lãi</h4>
                    </a>
                  </li>
                </ul>
                <div className="tab-content px-1 pt-1 pb-1 bg-content-tab">
                  <div
                    role="tabpanel"
                    className="tab-pane active"
                    id="tab-detailtt"
                    aria-labelledby="base-tab1"
                  >
                    <LanThanhToanView
                      List={List}
                      TongCanThanhToan={TongCanThanhToan}
                      TongPhiKhac={TongPhiKhac}
                      TongPhiKho={TongPhiKho}
                      TongThanhToan={TongThanhToan}
                      TongTienGoc={TongTienGoc}
                      TongTienLai={TongTienLai}
                      totalRow={totalRow}
                      TongPhiKhacHangKy={TongPhiKhacHangKy}
                      handlePageChange={this.handlePageChange()}
                      pageIndex={dataSearch.pageIndex}
                      pageSize={dataSearch.pageSize}
                      Type={Type}
                      StatusPaidHo={StatusPaidHo}
                      HasTatToanChoDuyet={this.state.HasTatToanChoDuyet}
                    ></LanThanhToanView>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div class="from-button-modal">
            <div class="row">
              <div class="col-md-9">{buttonLeft}</div>
              <div class="col-md-3 text-right">
                <button
                  type="button"
                  class="btn btn-new-main btn-closenew"
                  onClick={props.onHide}
                >
                  <span class="btn-icon-left">
                    <i class="mdi mdi-close"></i>
                  </span>
                  Đóng
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ThayDoiKyThanhToan;
